'use client'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Header from 'components/Header'
import SecNav from 'components/SecNav'
import { STRAPI } from 'config/apis'
import { useMainContext } from 'utils/context'

const TemplateLayout = ({ header, nav, children }) => {
  const { menu } = useMainContext()
  const [components, setComponents] = useState({})
  const pathname = usePathname()

  async function getData() {
    try {
      const reqPage = await fetch(STRAPI.PAGE.replace('{link}', pathname))
      const components = await reqPage.json()
      setComponents(components.data.pop())
    } catch (error) {}
  }

  useEffect(() => {
    getData()
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      {(header?.img ||
        components?.attributes?.base.imagen.data?.attributes?.url) && (
        <Header
          img={
            header?.img || components.attributes.base.imagen.data.attributes.url
          }
          title={header?.title || components?.attributes?.base.titulo}
        />
      )}
      {nav && menu.length ? (
        <SecNav items={menu} elements={nav.elements} bg={nav.bg} />
      ) : null}
      {children}
    </>
  )
}

export default TemplateLayout
